<div class="w-100 h-100 monitor-dashboard-page-shell">
  <div class="row">
    <div class="col-md-12">
      <div class="card card_layout">
        <div class="card-header">
          <div class="form-row justify-content-between align-items-center w-100">
            <div class="col-auto">
              <label class="card_header_text mb-0 font-weight-bold">
                {{ $t('monitorDashboard.complaintsTimelineDetailsTitle') }}
                <span class="monitor-dashboard-chart-total">({{ totalCount }})</span>
              </label>
            </div>
            <div class="col-auto mt-2">
              <button type="button" class="btn btn-primary btn-action" @click="onExport">
                {{ $t('monitorDashboard.exportToExcel') }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3">
              <div class="input-group all-requests-details-client-filter">
                <div class="all-requests-details-client-autocomplete-wrap">
                  <v-autocomplete v-model="senderNameFilter" :items="senderNameOptions"
                    :placeholder="$t('monitorDashboard.senderName')" hide-details dense solo flat clearable attach
                    :menu-props="senderNameMenuProps" class="all-requests-details-client-autocomplete"
                    @change="onSenderNameChange" />
                </div>
                <div class="input-group-append">
                  <span class="input-group-text right gray">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group all-requests-details-client-filter">
                <div class="all-requests-details-client-autocomplete-wrap">
                  <v-autocomplete v-model="clientNameFilter" :items="clientNameOptions"
                    :placeholder="$t('monitorDashboard.clientName')" hide-details dense solo flat clearable attach
                    :menu-props="clientNameMenuProps" class="all-requests-details-client-autocomplete"
                    @change="onClientNameChange" />
                </div>
                <div class="input-group-append">
                  <span class="input-group-text right gray">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-1 mt-1">
              <button type="button" class="btn btn-primary btn-action flex-shrink-0" @click="resetLocalFilters">
                {{ $t('shared.reset') }}
              </button>
            </div>
          </div>

          <v-data-table :headers="headers" :items="rows" :total-items="totalCount" :pagination.sync="pagination"
            @update:pagination="updatePaginate" :rows-per-page-text="$t('shared.rowsPerPage')"
            :rows-per-page-items="[10, 25, 50, 100]" :loading="isLoading" item-key="rowKey"
            class="elevation-1 table-striped">
            <template v-slot:headers="props">
              <tr>
                <th class="text-center" v-for="header in props.headers" :key="header.text"
                  :class="['column sortable', pagination.descending ? 'desc' : 'asc', (header.value === pagination.sortBy) && isSorted ? 'active' : '']"
                  @click="header.sortable ? changeSort(header.value) : null" :width="header.width ? header.width : ''">
                  <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-center">{{ formatCreatedDate(props.item.createdDate) }}</td>
                <td class="text-center">{{ formatCustomerType(props.item.customerType) }}</td>
                <td class="text-center">{{ props.item.senderName }}</td>
                <td class="text-center">{{ props.item.clientName }}</td>
                <td class="text-center">{{ props.item.smsServiceProvider }}</td>
                <td class="text-center">{{ props.item.serviceProvider }}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <div class="text-center py-4">{{ $t('monitorDashboard.complaintsTimelineDetailsEmpty') }}</div>
            </template>
          </v-data-table>

          <div class="col-md-12 mb-3">
            <div class="form-row justify-content-start align-items-center">
              <div class="col-auto ml-5">
                <a href="" class="link_secondary" style="text-decoration: underline !important"
                  @click.prevent="goBack">{{ $t('shared.back') }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
